import {h, Component, Fragment} from 'preact';
import {route} from "preact-router";
import {t, Trans} from "@lingui/macro"

import Page from "../../../services/page-data-feed";
import PFeed from "../../../services/prematch-feed";
import Ticket from "../utils/ticket-logic.jsx";
import SchedulesTimeFilter from "../utils/schedules-time-filter.jsx";

import * as P from "../desktop-templates/prematch-tournament.jsx";
import * as M from "../desktop-templates/prematch-menu.jsx";
import * as S from "../desktop-templates/prematch-single-event.jsx";
import * as I from "../utils/icons.jsx"

import {TournamentCard} from "../mobile-pages/prematch-tournament.jsx";
import AwrabetPrematchTournament, { PrematchTournamentContent as AwrabetPrematchTournamentContent } from '../../awrabet/desktop-components/prematch-tournament.jsx';

export default class PrematchTournament extends AwrabetPrematchTournament {
	render({tournament, tournamentCard}) {
		const {sport, category} = PFeed.getWithParents(tournament.id);
		
		return <div>
		  <P.CardHeaderRow>
			<P.ThreeDots />
			<P.TournamentSportName>{sport.name}</P.TournamentSportName>
			<P.TournamentFullName>{category.name} - {tournament.name}</P.TournamentFullName>
			<P.CardHeaderSports>
			  <P.TournamentCardButtonCell />
			  <P.TournamentCardButtonCell>
				  <div onClick={e => Page.closeTournament(tournament.id)} class="p-1 text-white h-full w-8">
					  <I.CloseIconSlim class="h-full fill-current" />
				  </div>
			  </P.TournamentCardButtonCell>
			</P.CardHeaderSports>
		  </P.CardHeaderRow>
		  {tournamentCard && <PrematchTournamentContent {...{sport, category, tournament, tournamentCard}} />}
		</div>
	}
}

export class PrematchTournamentContent extends AwrabetPrematchTournamentContent {
	render({sport, category, tournament, tournamentCard}) {
		const card = this.state.tournamentCard || tournamentCard;
		
		const giornateSorted = this.state.giornateSorted;
		const displayRuleFiltered = card.displayRule;

		const sortedCategories = Object.values(card.categories).sort((a, b) => a.order - b.order);
		const sortedTabs = Object.values(card.categories[this.state.currentCategory].sub).sort((a, b) => a.order - b.order);

		const isDivisible = card.market.divisible || card.displayRule.length > 12;
		
		return <div>
		  {sortedCategories.length > 1 && <P.TournamentBigTabsContainer>
			<P.TabsWrapper>
			  {sortedCategories.map(tab => (
				<P.TabButton active={this.isCurrentCategory(tab)} onClick={() => this.setCategory(tab)}>{tab.name}</P.TabButton>
			  ))}
			</P.TabsWrapper>
			<P.TabsCollapseButton onClick={e => this.setState({tabsOpen: !this.state.tabsOpen})}>
			  <I.UpArrowIcon class={"h-4 transition-transform "+(this.state.tabsOpen ? '' : 'rotate-180')} />
			</P.TabsCollapseButton>
		  </P.TournamentBigTabsContainer>}
		  {this.state.tabsOpen && <P.SubTabsContainer>
			  {sortedTabs.map(tab => (
				<P.SubTabButton active={this.isCurrentTab(tab)} onClick={() => this.setTab(tab)}>{tab.name}</P.SubTabButton>
			  ))}
		  </P.SubTabsContainer>}
		  <P.OddsTableHeadRow>
			<P.HeadRowCellId><Trans>Stats</Trans></P.HeadRowCellId>
			<P.HeadRowCellId><Trans>ID</Trans></P.HeadRowCellId>
			<P.HeadRowCellTime><Trans>Time</Trans></P.HeadRowCellTime>
			<P.HeadRowCellEvent><Trans>Event</Trans></P.HeadRowCellEvent>
			<P.OddsWidthContainerLarge>
			  {!isDivisible && displayRuleFiltered.map(outcome => <P.HeadOddCell>{outcome.name}</P.HeadOddCell>)}
			  <P.HeadMoreCell />
			</P.OddsWidthContainerLarge>
		  </P.OddsTableHeadRow>
			{giornateSorted.filter(s => SchedulesTimeFilter.isEventAllowed(s[0])).map(eventsList => <div>
			  <P.TableRowDate>
				<P.DateCell>{this.getLocalEventDate(eventsList[0])}</P.DateCell>
			  </P.TableRowDate>
			  {eventsList.filter(s => SchedulesTimeFilter.isEventAllowed(s)).map((event, idx) => <div>
				<P.EventRow isOdd={idx % 2}>
					<P.HeadRowCellId onClick={e => Page.openEventStats(event)}><I.StatsIconRegular class="h-4" /></P.HeadRowCellId>
					<P.HeadRowCellId>{event.short}</P.HeadRowCellId>
					<P.HeadRowCellTime>{this.getLocalEventTime(event)}</P.HeadRowCellTime>
					<P.ContentRowCellEvent><a href="javascript:void(0);" class="cursor-pointer hover:underline" onClick={e => this.openEvent(event)}>{event.home}{event.away != null ? ' - '+event.away : ''}</a></P.ContentRowCellEvent>
					{!isDivisible ? <P.OddsWidthContainerLarge>
						{displayRuleFiltered.map(outcome => {
							const [marketCode, outcomeCode] = outcome.id.split('.');
							const market = event.sub['/market/'+event.id.split('/').slice(-1)[0]+'/'+marketCode] || {sub:{},id:''}
							const odd = market.sub[market.id.replace('market', 'odd')+'/'+outcomeCode] || {value: 0, active: false};
							return <P.EventOddButton
										value={odd.value} 
										active={odd.active} 
										onClick={() => Ticket.togglePrematchOdds(odd.id)} 
										selected={Ticket.hasPrematchOdds(odd.id)} />;
						})}
					  <P.MoreButton onClick={e => this.openEvent(event)}>+</P.MoreButton>
					</P.OddsWidthContainerLarge>
					: <P.OddsWidthContainerLarge>
						<P.OddsWidthEmpty>
						</P.OddsWidthEmpty>
						<P.MoreButton onClick={e => this.openEvent(event)}>+</P.MoreButton>
					</P.OddsWidthContainerLarge>}
				</P.EventRow>
				<div>
				  {isDivisible &&<P.SubTabsOddsContainer>
					  { displayRuleFiltered.filter((outcome, idx, arr) => {
						const [marketCode, outcomeCode] = outcome.id.split('.');
						const market = event.sub['/market/'+event.id.split('/')[2]+'/'+marketCode] || {sub:{},id:''}
						const odd = market.sub[market.id.replace('market', 'odd')+'/'+outcomeCode];
						return odd && odd.value;
					}).map((outcome, idx, arr) => {
						const [marketCode, outcomeCode] = outcome.id.split('.');
						const market = event.sub['/market/'+event.id.split('/').slice(-1)[0]+'/'+marketCode] || {sub:{},id:''}
						const odd = market.sub[market.id.replace('market', 'odd')+'/'+outcomeCode] || {value: 0, active: false};
						return <S.OutcomeButton
								   key={odd.id}
									selected={Ticket.hasPrematchOdds(odd.id)} 
									onClick={() => Ticket.togglePrematchOdds(odd.id)}
								   >
						  <S.OutcomeName>{odd.name}</S.OutcomeName>
						  <S.OutcomeValue
							  selected={Ticket.hasPrematchOdds(odd.id)} 
							  value={odd.value} />
						</S.OutcomeButton>;
					})}
				  </P.SubTabsOddsContainer>}
				</div>
			  </div>)}
			</div>)}
		  <M.BlankSeparator />
		</div>
	}
}
